
(()=>{
	window.addEventListener('cartcount:update', checkCatrItemsNotes);
	document.addEventListener('DOMContentLoaded', ()=>{
		fetch('/cart.js')
			.then(data => data.json())
			.then(data => {
				checkCatrItemsNotes(data, 'onload')
			})
		
	});

	function checkCatrItemsNotes(e, type){
		let items = {};
		if(type == 'onload') {
			items = e.items;
		} else {
			items = e.detail.items;
		}
		
		let orderNote = getAllProperties(items);
		updateOrderNote(orderNote)

		function getAllProperties(items) {
				let orderNote = '';
				let orderJson = [];

				if(items[0]) {
					items.forEach(item => {
						let orderJsonItem = {};
							for (const [key, value] of Object.entries(item.properties)) {
									orderNote += key + ': ' + value + '\r\n';
									orderJsonItem[key] = value;
							}
							if (orderNote.trim().length > 0) {
								orderJsonItem["timestamp"] = Date.now();
							}
							orderJson.push(orderJsonItem);
							orderNote += '\r\n\r\n';
					})
				}

				orderJson = JSON.stringify(orderJson);
				if (orderJson.length > 5) {
					return orderNote.trim() + '---------' + orderJson;
				}
				return orderNote.trim();
		}

		function updateOrderNote(orderNote) {
				fetch(
						'/cart/update.js', 
						{
								method: "POST",
								headers: {
										'Content-Type': 'application/json'
								},
								body: JSON.stringify({ note: orderNote })
						}
				).then(data => {
						//location.reload();
				})
		}
	}

})();
